let config = {
  emailjs: {
    serviceID: "service_yz2gmhe",
    templateID: "template_bks2yg3",
    userID: "hPQFzZYui_11_s8eY"
  }
};

export default config;
